import React, { createContext, useContext } from "react"

import { getCurrentLang } from "utils"

import en_translations from "locales/en/translation.json"
import en_links from "locales/en/links.json"

import pl_translations from "locales/pl/translation.json"
import pl_links from "locales/pl/links.json"

const LocaleContext = createContext()

function LocaleProvider({ location, translations = [], children }) {
  const langs = ["pl", "en"]
  const lang = getCurrentLang(location?.pathname)

  const en = {
    ...en_translations,
    ...en_links,
  }

  const pl = {
    ...pl_translations,
    ...pl_links,
  }

  const getNewsLink = code => {
    const key = "news_link"

    switch (code) {
      case "pl":
        return pl_links[key]
      default:
        return en_links[key]
    }
  }

  const createLangHref = code => {
    if (translations?.length > 0) {
      const trans = translations.find(item => item.code === code)

      if (trans) {
        return trans.path
      }

      return getNewsLink(code)
    } else {
      if (lang === "en") {
        let arr_key = "/"

        Object.keys(en_links).forEach(key => {
          if (en_links[key] === location?.pathname) {
            arr_key = key
          }
        })

        if (code === "pl") {
          return pl_links[arr_key]
        } else {
          return en_links[arr_key]
        }
      }

      if (lang === "pl") {
        let arr_key = "/pl/"

        Object.keys(pl_links).forEach(key => {
          if (pl_links[key] === location?.pathname) {
            arr_key = key
          }
        })

        if (code === "en") {
          return en_links[arr_key]
        } else {
          return pl_links[arr_key]
        }
      }
    }
  }

  const languages = { en, pl }
  const t = key => languages[lang]?.[key] || key

  const langs_switcher = [lang, ...langs.filter(code => code !== lang)].map(
    code => ({ code, href: createLangHref(code) })
  )

  return (
    <LocaleContext.Provider value={{ langs_switcher, langs, lang, t }}>
      {children}
    </LocaleContext.Provider>
  )
}

const useLocale = () => useContext(LocaleContext)

export { useLocale }

export default LocaleProvider
